import React from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'hooks/use-redux'
import type { Artist } from 'types/artist'
import {
  BROWSE_LIBRARIES,
  IS_ARTIST,
  LIVE_LIBRARIES,
} from '@disco/constants/FeatureTypes'
import { getArtists } from '@disco/state-management/selectors/artists'
import type { State as ArtistsState } from '@disco/state-management/reducers/artists'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { getClientLibraries } from '@disco/state-management/selectors/client-libraries'
import { isClientLibrariesTrial } from '@disco/state-management/selectors/user'
import { useComposerInsteadOfArtist } from '@disco/utils/composerInsteadOfArtist'
import LibrariesList from './LibrariesList'

const LibrariesListContainer = (): React.ReactNode => {
  const location = useLocation()
  const libraries = useSelector(getClientLibraries)
  const artists = useSelector(getArtists)
  const clientLibrariesTrial: boolean = useSelector(isClientLibrariesTrial)
  const liveLibrariesEnabled: boolean =
    useFeatureEnabled(LIVE_LIBRARIES) && !clientLibrariesTrial
  const browseLibrariesEnabled: boolean = useFeatureEnabled(BROWSE_LIBRARIES)
  const isArtist = useFeatureEnabled(IS_ARTIST)
  const isLibrariesEmpty = libraries.clientLibraries.length === 0
  const typeData = useComposerInsteadOfArtist()
  const librariesListProps = {
    libraries,
    artists: artists as ArtistsState & { list: Artist[] },
    clientLibrariesTrial,
    liveLibrariesEnabled,
    browseLibrariesEnabled,
    isArtist,
    isLibrariesEmpty,
    typeData,
    location,
  }
  return <LibrariesList {...librariesListProps} />
}

export default LibrariesListContainer
